import { findMembershipProduct } from "../space/product/SpaceProductSection";
import type { MembershipProduct } from "../space/SpaceType";
import { PAGE_SHELL_BG, PAGE_SHELL_DEFAULT_TITLE, type PageShellBgState } from "./pageShellBg";

type SpaceTab = { key: string; label?: string };

/** 空间 Tab：首页粉底+「空间名-首页」；其余白底+ Tab/产品名 */
export function resolveSpaceTabShellBg(input: {
  activeTab: string;
  spaceName?: string | null;
  tabs: SpaceTab[];
  membershipProducts: MembershipProduct[];
}): PageShellBgState {
  const { activeTab, spaceName, tabs, membershipProducts } = input;
  const name = spaceName?.trim() || PAGE_SHELL_DEFAULT_TITLE;

  if (activeTab === "home") {
    return {
      bg: PAGE_SHELL_BG.spaceHome,
      front: "#ffffff",
      title: `${name}-首页`,
    };
  }

  const currentTab = tabs.find((t) => t.key === activeTab);
  const productModule = findMembershipProduct(membershipProducts, activeTab);
  let title = PAGE_SHELL_DEFAULT_TITLE;
  if (activeTab === "mine") {
    title = "我的";
  } else if (productModule?.displayName?.trim()) {
    title = productModule.displayName.trim();
  } else if (currentTab?.label?.trim()) {
    title = currentTab.label.trim();
  }

  return {
    bg: PAGE_SHELL_BG.spaceLight,
    front: "#000000",
    title,
  };
}
